import React, { useState, useEffect, useRef } from 'react';
import './Carousel.css';

const Carousel = ({ title, subtitle }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const intervalRef = useRef(null);

  // Projetos com imagens limpas
  const projects = [
    {
      id: 1,
      image: `${process.env.PUBLIC_URL}/images/projeto1.jpg`,
      alt: "Projeto 1"
    },
    {
      id: 2,
      image: `${process.env.PUBLIC_URL}/images/projeto2.jpg`,
      alt: "Projeto 2"
    },
    {
      id: 3,
      image: `${process.env.PUBLIC_URL}/images/projeto3.jpg`,
      alt: "Projeto 3"
    },
    {
      id: 4,
      image: `${process.env.PUBLIC_URL}/images/projeto4.jpg`,
      alt: "Projeto 4"
    },
    {
      id: 5,
      image: `${process.env.PUBLIC_URL}/images/projeto5.jpg`,
      alt: "Projeto 5"
    }
  ];

  // Auto-play functionality
  useEffect(() => {
    if (isAutoPlaying) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % projects.length);
      }, 4000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isAutoPlaying, projects.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 3000);
  };

  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % projects.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 3000);
  };

  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? projects.length - 1 : prev - 1);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 3000);
  };

  return (
    <section id="carousel" className="futuristic-carousel">
      <div className="carousel-container">
        {/* Header */}
        <div className="carousel-header">
          <h2 className="carousel-title">{title}</h2>
          <p className="carousel-subtitle">{subtitle}</p>
        </div>

        {/* Main Carousel */}
        <div className="carousel-main">
          {/* Background Effects */}
          <div className="carousel-bg-effects">
            {Array.from({ length: 20 }, (_, i) => (
              <div
                key={i}
                className="floating-particle"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 4}s`,
                  animationDuration: `${3 + Math.random() * 4}s`
                }}
              />
            ))}
          </div>

          {/* Project Cards */}
          <div className="carousel-track">
            {projects.map((project, index) => {
              const isActive = index === currentIndex;
              const isPrev = index === (currentIndex - 1 + projects.length) % projects.length;
              const isNext = index === (currentIndex + 1) % projects.length;
              
              let className = 'project-card';
              if (isActive) className += ' active';
              else if (isPrev) className += ' prev';
              else if (isNext) className += ' next';
              else className += ' hidden';

              return (
                <div
                  key={project.id}
                  className={className}
                  onClick={() => goToSlide(index)}
                >
                  <img 
                    src={project.image}
                    alt={project.alt}
                    className="project-image"
                    loading="lazy"
                  />
                </div>
              );
            })}
          </div>

          {/* Navigation Controls */}
          <div className="carousel-controls">
            <button className="control-btn prev-btn" onClick={prevSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            <button className="control-btn next-btn" onClick={nextSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Indicators */}
        <div className="carousel-indicators">
          {projects.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            >
              <div className="indicator-progress">
                <div 
                  className="progress-fill"
                  style={{
                    animationDuration: index === currentIndex && isAutoPlaying ? '4s' : '0s'
                  }}
                />
              </div>
            </button>
          ))}
        </div>

        {/* Project Counter */}
        <div className="project-counter">
          <span className="current-number">
            {String(currentIndex + 1).padStart(2, '0')}
          </span>
          <span className="separator">/</span>
          <span className="total-number">
            {String(projects.length).padStart(2, '0')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default Carousel; 
